<template>
  <div class="console">

    <router-view></router-view>
    <above-nav></above-nav>
    <side-nav></side-nav>

  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import aboveNav from 'components/abovenav/AboveNav'
  import sideNav from 'components/sidenav/SideNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
      }
    },
    created(){
      let language = loadLocal('language', false);
      if (language !== false) {
        if (language === 'en') {
          this.$i18n.locale = 'en-US';
        } else {
          this.$i18n.locale = 'zh-CN';
        }
      }
      this.QueryManagerRooms();
    },
    components:{
      sideNav,
      aboveNav,
    },
    methods: {
      QueryManagerRooms(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'QueryManagerRooms',
            id: this.id
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            let list = response.list;
            saveLocal('schoollist', list);
            this.schoollist = list;
            this.schoolNow = list[0];
            saveLocal('schoolNow', this.schoolNow);
          }
        }).catch((err) => {

        });
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.console
  width:100%
  height:100%
</style>



// WEBPACK FOOTER //
// src/page/console/Console.vue